/*
  Lush Life Records: "Shop these records" cards for blog posts.
  Loaded by a Custom Liquid section on the Blog posts template.

  Marker to paste in a post's code view, under the entry it belongs to:
  <p class="ll-record"><a href="/products/PRODUCT-HANDLE">Shop the 1981 Japanese CBS/Sony pressing of <em>Sketches of Spain</em></a></p>

  Optional group, hidden automatically once every record in it has sold:
  <div class="ll-records"><h2>Shop these records</h2> ...markers... </div>

  Sold out, unpublished or deleted records lose their card.
  If anything fails, the plain link stays in place.
*/
(function () {
  var S = window.Shopify || {};
  var CURRENCY = (S.currency && S.currency.active) || 'AUD';
  var ROOT = (S.routes && S.routes.root) || '/';
  var CART_URL = (window.routes && window.routes.cart_url) || ROOT + 'cart';

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  function money(cents) {
    var digits = cents % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: CURRENCY,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(cents / 100);
    } catch (err) {
      return '$' + (cents / 100).toFixed(digits);
    }
  }

  // "Miles Davis - Sketches Of Spain (1981 Japanese CBS/Sony Vinyl LP)"
  // becomes artist, album and pressing. Titles without " - " keep the
  // whole title as the album line.
  function splitTitle(title) {
    var out = { artist: '', album: title, pressing: '' };
    var dash = title.match(/^(.+?)\s[-\u2013\u2014]\s(.+)$/);
    if (dash) {
      out.artist = dash[1];
      out.album = dash[2];
    }
    var paren = out.album.match(/^(.*\S)\s*\(([^()]+)\)\s*$/);
    if (paren) {
      out.album = paren[1];
      out.pressing = paren[2];
    }
    return out;
  }

  function imageUrl(src, width) {
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (err) {
      return src;
    }
  }

  function removeMarker(node) {
    var group = node.closest('.ll-records');
    node.remove();
    if (group && !group.querySelector('.ll-record, .ll-card')) group.hidden = true;
  }

  function showMessage(msg, text) {
    msg.textContent = text + ' ';
    var link = el('a', null, 'View cart');
    link.href = CART_URL;
    msg.appendChild(link);
  }

  function addToCart(button, variantId, msg, productUrl) {
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');

    // Same request Rise's own product form sends, so the theme's cart
    // notification or drawer opens just as it does on a product page.
    // Deliberately not a <form>: apps that decorate add-to-cart forms
    // (trust badges, back-in-stock) would otherwise inject into the card.
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var data = new FormData();
    data.append('id', variantId);
    data.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      data.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(
        function (res) {
          if (res.status) {
            // Shopify cart error, usually "All 1 ... are in your cart"
            showMessage(msg, res.description || 'This record could not be added.');
            return;
          }
          button.textContent = 'Added';
          try {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          } catch (err) {
            // Added, but the notification could not open: go to the cart page
            window.location = CART_URL;
          }
        },
        function () {
          // The request itself failed: send them to the record's page
          window.location = productUrl;
        }
      );
  }

  function render(node, product) {
    var variant = (product.variants || []).filter(function (v) { return v.available; })[0];
    if (!product.available || !variant) {
      removeMarker(node);
      return;
    }

    var t = splitTitle(product.title);
    var label = t.album + (t.pressing ? ', ' + t.pressing : '');
    var url = ROOT + 'products/' + product.handle;

    var card = el('div', 'll-card');

    var cover = el('a', 'll-card__cover');
    cover.href = url;
    cover.tabIndex = -1;
    cover.setAttribute('aria-hidden', 'true');
    if (product.featured_image) {
      var img = el('img');
      img.src = imageUrl(product.featured_image, 320);
      img.alt = '';
      img.width = 160;
      img.height = 160;
      img.loading = 'lazy';
      cover.appendChild(img);
    }

    var info = el('div', 'll-card__info');
    if (t.artist) info.appendChild(el('span', 'll-card__artist', t.artist));
    info.appendChild(el('span', 'll-card__album', t.album));
    if (t.pressing) info.appendChild(el('span', 'll-card__pressing', t.pressing));
    info.appendChild(el('span', 'll-card__price', money(variant.price)));
    var msg = el('span', 'll-card__msg');
    msg.setAttribute('role', 'status');
    info.appendChild(msg);

    var actions = el('div', 'll-card__actions');
    var buy = el('button', 'll-card__btn', 'Add to cart');
    buy.type = 'button';
    buy.setAttribute('aria-label', 'Add ' + label + ' to cart');
    buy.addEventListener('click', function () { addToCart(buy, variant.id, msg, url); });

    var view = el('a', 'll-card__btn ll-card__btn--secondary', 'View record');
    view.href = url;
    view.setAttribute('aria-label', 'View ' + label);

    actions.appendChild(buy);
    actions.appendChild(view);
    card.appendChild(cover);
    card.appendChild(info);
    card.appendChild(actions);
    node.replaceWith(card);
  }

  function init() {
    document.querySelectorAll('.ll-record').forEach(function (node) {
      var link = node.querySelector('a[href*="/products/"]');
      if (!link) return;
      var match = new URL(link.href, window.location.href).pathname.match(/\/products\/([^\/?#]+)/);
      if (!match) return;
      fetch(ROOT + 'products/' + match[1] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 404) {
            removeMarker(node);
            return null;
          }
          return r.ok ? r.json() : null;
        })
        .then(function (product) { if (product) render(node, product); })
        .catch(function () { /* leave the plain link in place */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();